import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-sovereign-navy pt-24 pb-12 border-t border-white/5" data-id="element-59">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20" data-id="element-61">
          <div className="md:col-span-2" data-id="element-62">
            <Link to="/" className="inline-block" data-id="element-63">
              <h3 className="text-2xl font-serif text-white mb-6" data-id="element-64">
                Sovereign{' '}
                <span className="text-sovereign-gold italic" data-id="element-65">eTims</span>
              </h3>
            </Link>
            <p className="text-gray-400 font-light max-w-md leading-relaxed" data-id="element-66">
              The premier KRA eTims integration for WooCommerce. Bringing
              sophistication to compliance, and elegance to operations.
            </p>
          </div>

          <div data-id="element-67">
            <h4 className="text-sovereign-gold text-sm uppercase tracking-widest mb-6" data-id="element-68">
              Platform
            </h4>
            <ul className="space-y-4" data-id="element-69">
              <li data-id="element-70">
                <Link to="/features" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-71">
                  Features
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/pricing" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-73">
                  Pricing
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/integration" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-75">
                  Integration
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/changelog" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-77">
                  Changelog
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-78">
            <h4 className="text-sovereign-gold text-sm uppercase tracking-widest mb-6" data-id="element-79">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-80">
              <li data-id="element-81">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-82">
                  About
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-84">
                  Contact
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-86">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors duration-300 font-light" data-id="element-88">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-89">
          <p className="text-gray-500 text-sm font-light" data-id="element-90">
            © {new Date().getFullYear()} Sovereign eTims. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-91">
            <div className="w-8 h-1 bg-sovereign-gold/20" data-id="element-92" />
            <div className="w-8 h-1 bg-sovereign-gold/20" data-id="element-93" />
            <div className="w-8 h-1 bg-sovereign-gold/20" data-id="element-94" />
          </div>
        </div>
      </div>
    </footer>;
}